module.exports = __webpack_public_path__ + "static/media/thumbnail.7ea68a69.png";